import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const CATEGORIES = [
  { value: 'general', label: 'General', bg: '#f3f4f6', color: '#374151' },
  { value: 'business', label: 'Business', bg: '#eff6ff', color: '#2563eb' },
  { value: 'industry', label: 'Industry', bg: '#f5f3ff', color: '#7c3aed' },
  { value: 'local', label: 'Local', bg: '#ecfdf5', color: '#059669' },
  { value: 'company', label: 'Company', bg: '#fffbeb', color: '#d97706' },
  { value: 'weather', label: 'Weather', bg: '#ecfeff', color: '#0891b2' },
  { value: 'sports', label: 'Sports', bg: '#fef2f2', color: '#dc2626' },
  { value: 'entertainment', label: 'Entertainment', bg: '#fdf2f8', color: '#db2777' }
];

const DEFAULT_FORM = { title: '', content: '', category: 'general', source: '' };

const VOICES = [
  { value: 'male_us', label: 'US Voice — Male' },
  { value: 'female_us', label: 'US Voice — Female' },
  { value: 'male_us_2', label: 'US Voice — Male (alt)' },
  { value: 'female_us_2', label: 'US Voice — Female (alt)' },
  { value: 'male_uk', label: 'UK Voice — Male' },
  { value: 'female_uk', label: 'UK Voice — Female' },
];

const Svg = ({ type, size = 16 }) => {
  const icons = {
    play: <polygon points="5,3 19,12 5,21" fill="currentColor" />,
    stop: <rect x="4" y="4" width="16" height="16" rx="2" fill="currentColor" />,
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    edit: <><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></>,
    trash: <><polyline points="3,6 5,6 21,6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    globe: <><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>,
    check: <><polyline points="20,6 9,17 4,12"/></>,
    x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    newspaper: <><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6Z"/></>,
    mic: <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/></>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></>,
    volume: <><polygon points="11,5 6,9 2,9 2,15 6,15 11,19"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></>,
    pin: <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></>,
    bot: <><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>
  );
};

const inputStyle = {
  width: '100%', border: '1.5px solid #e5e7eb', borderRadius: 10,
  padding: '11px 14px', fontSize: 14, outline: 'none',
  fontFamily: "'Outfit', sans-serif", boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};
const focusIn = (e) => e.target.style.borderColor = '#7c3aed';
const focusOut = (e) => e.target.style.borderColor = '#e5e7eb';

export default function News() {
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({ ...DEFAULT_FORM });
  const [saving, setSaving] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [filterCategory, setFilterCategory] = useState('all');
  const [activeTab, setActiveTab] = useState('approved');
  const [approving, setApproving] = useState(null);
  const [newsVoice, setNewsVoice] = useState('male_us');
  const [playingId, setPlayingId] = useState(null);
  const [toast, setToast] = useState(null);
  const [audioRef] = useState({ current: null });
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };

  useEffect(() => { if (!token) { navigate('/login'); return; } fetchNews(); }, [token, navigate]);

  const fetchNews = async () => {
    try { setLoading(true); const res = await fetch(`${API}/news`, { headers }); if (res.status === 401) { navigate('/login'); return; } if (res.ok) { const d = await res.json(); setNews(d.news || []); } } catch { setNews([]); } finally { setLoading(false); }
  };

  const fetchIndustryNews = async () => {
    setFetching(true);
    try {
      const res = await fetch(`${API}/news/fetch-industry?max_items=10`, { method: 'POST', headers });
      if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Failed'); }
      const data = await res.json();
      await fetchNews(); setActiveTab('pending');
      const loc = data.location ? ` in ${data.location}` : '';
      alert(`Fetched ${data.items_fetched} news items for your ${data.business_type} business${loc}!\nGlobal: ${data.global_count || 0}  Local: ${data.local_count || 0}`);
    } catch (err) { alert('Failed: ' + err.message); }
    finally { setFetching(false); }
  };

  const handleApprove = async (id) => {
    setApproving(id);
    try {
      const res = await fetch(`${API}/news/${id}/approve?voice=${newsVoice}`, { method: 'POST', headers });
      if (res.ok) {
        await fetchNews();
        setToast('News approved — now live in your broadcast schedule');
        setTimeout(() => setToast(null), 4000);
      }
    } catch {} finally { setApproving(null); }
  };

  const handleReject = async (id, title) => {
    if (!window.confirm(`Reject "${title}"? This will remove it.`)) return;
    try { const res = await fetch(`${API}/news/${id}/reject`, { method: 'POST', headers }); if (res.ok) await fetchNews(); } catch {}
  };

  const handleApproveAll = async () => {
    const p = news.filter(n => !n.is_active);
    if (!p.length) return;
    if (!window.confirm(`Approve all ${p.length} pending items? Audio will be generated for each.`)) return;
    for (const item of p) { setApproving(item.id); await handleApprove(item.id); }
    setApproving(null);
  };

  const handleCreate = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const params = new URLSearchParams({ title: formData.title, content: formData.content, category: formData.category });
      if (formData.source) params.append('source', formData.source);
      const res = await fetch(`${API}/news?${params.toString()}`, { method: 'POST', headers });
      if (!res.ok) throw new Error('Failed');
      await fetchNews(); closeModal();
    } catch (err) { alert('Failed: ' + err.message); }
    finally { setSaving(false); }
  };

  const handleEdit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const params = new URLSearchParams();
      if (formData.title) params.append('title', formData.title);
      if (formData.content) params.append('content', formData.content);
      if (formData.category) params.append('category', formData.category);
      const res = await fetch(`${API}/news/${editingId}?${params.toString()}`, { method: 'PUT', headers });
      if (!res.ok) throw new Error('Failed');
      await fetchNews(); closeModal();
    } catch (err) { alert('Failed: ' + err.message); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    try { const res = await fetch(`${API}/news/${id}`, { method: 'DELETE', headers }); if (res.ok) await fetchNews(); } catch { alert('Failed'); }
  };

  const openEdit = (item) => {
    setFormData({ title: item.title || '', content: item.content || '', category: item.category || 'general', source: item.source || '' });
    setEditing(true); setEditingId(item.id); setShowModal(true);
  };

  const closeModal = () => { setShowModal(false); setEditing(false); setEditingId(null); setFormData({ ...DEFAULT_FORM }); };
  const getCategoryInfo = (cat) => CATEGORIES.find(c => c.value === cat) || CATEGORIES[0];

  const playAudio = (url, id) => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; if (playingId === id) { setPlayingId(null); return; } }
    const a = new Audio(url); a.onended = () => setPlayingId(null); a.play(); audioRef.current = a; setPlayingId(id);
  };

  const formatDate = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
  };

  const isRSS = (source) => source && source.startsWith('RSS:');
  const pending = news.filter(n => !n.is_active);
  const approved = news.filter(n => n.is_active);
  const currentList = activeTab === 'pending' ? pending : approved;
  const filtered = currentList.filter(n => filterCategory === 'all' || n.category === filterCategory);

  if (loading) return (
    <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e9d5ff', borderTopColor: '#7c3aed', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1200, margin: '0 auto', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }`}</style>
      {toast && (
        <div style={{
          position: 'fixed', top: 24, right: 24, zIndex: 100,
          background: 'linear-gradient(135deg, #059669, #10b981)', color: '#fff',
          padding: '14px 24px', borderRadius: 12, fontSize: 14, fontWeight: 600,
          boxShadow: '0 8px 24px rgba(5,150,105,0.3)',
          display: 'flex', alignItems: 'center', gap: 10,
          animation: 'slideIn 0.3s ease-out',
          fontFamily: "'Outfit', sans-serif",
        }}>
          <Svg type="check" size={18} /> {toast}
        </div>
      )}
      <style>{`@keyframes slideIn { from { transform: translateX(100px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>News</h1>
          <p style={{ fontSize: 14, color: '#9ca3af', marginTop: 4 }}>{approved.length} approved &middot; {pending.length} pending review</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={fetchIndustryNews} disabled={fetching} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '12px 22px', borderRadius: 12, fontSize: 14, fontWeight: 600,
            border: 'none', cursor: fetching ? 'not-allowed' : 'pointer',
            background: fetching ? '#93c5fd' : 'linear-gradient(135deg, #2563eb, #3b82f6)',
            color: '#fff', fontFamily: "'Outfit', sans-serif",
            boxShadow: '0 4px 12px rgba(37,99,235,0.3)', transition: 'transform 0.15s',
          }}
          onMouseEnter={(e) => { if (!fetching) e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
          >
            <Svg type="globe" size={16} /> {fetching ? 'Fetching...' : 'Fetch Industry News'}
          </button>
          <button onClick={() => { setFormData({ ...DEFAULT_FORM }); setEditing(false); setShowModal(true); }} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: '#fff',
            border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 14, fontWeight: 600,
            cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
            boxShadow: '0 4px 12px rgba(124,58,237,0.3)', transition: 'transform 0.15s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
          >
            <Svg type="plus" size={16} /> Write Custom
          </button>
        </div>
      </div>

      {/* Info banner */}
      <div style={{
        background: 'linear-gradient(135deg, #eff6ff, #f5f3ff)', border: '1px solid #dbeafe',
        borderRadius: 14, padding: '16px 20px', marginBottom: 24, display: 'flex', alignItems: 'flex-start', gap: 14,
      }}>
        <div style={{ color: '#2563eb', flexShrink: 0, marginTop: 2 }}><Svg type="bot" size={24} /></div>
        <div style={{ fontSize: 13, color: '#1e40af' }}>
          <p style={{ fontWeight: 700, margin: '0 0 4px' }}>Auto-Curated Industry News</p>
          <p style={{ margin: 0 }}>Click <strong>"Fetch Industry News"</strong> to pull the latest headlines relevant to your business type and location. Review, edit if needed, then approve &mdash; audio is auto-generated and added to your broadcast schedule automatically.</p>
        </div>
      </div>

      {/* Tabs + Filters */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', background: '#f3f4f6', borderRadius: 10, padding: 3 }}>
          {[
            { key: 'approved', label: 'Approved', count: approved.length, activeColor: '#059669' },
            { key: 'pending', label: 'Pending', count: pending.length, activeColor: '#d97706' },
          ].map(t => (
            <button key={t.key} onClick={() => setActiveTab(t.key)} style={{
              position: 'relative', padding: '8px 18px', borderRadius: 8, fontSize: 13, fontWeight: 600,
              border: 'none', cursor: 'pointer', transition: 'all 0.15s',
              background: activeTab === t.key ? '#fff' : 'transparent',
              color: activeTab === t.key ? t.activeColor : '#6b7280',
              boxShadow: activeTab === t.key ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            }}>
              {t.label} ({t.count})
              {t.key === 'pending' && pending.length > 0 && activeTab !== 'pending' && (
                <span style={{
                  position: 'absolute', top: -4, right: -4, width: 18, height: 18,
                  background: '#d97706', color: '#fff', fontSize: 10, fontWeight: 700,
                  borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>{pending.length}</span>
              )}
            </button>
          ))}
        </div>

        <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}
          style={{ ...inputStyle, width: 'auto', minWidth: 160 }}>
          <option value="all">All Categories</option>
          {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>

        {activeTab === 'pending' && pending.length > 0 && (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
            <select value={newsVoice} onChange={(e) => setNewsVoice(e.target.value)}
              style={{ ...inputStyle, width: 'auto', minWidth: 180 }}>
              {VOICES.map(v => <option key={v.value} value={v.value}>{v.label}</option>)}
            </select>
            <button onClick={handleApproveAll} style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '10px 18px', borderRadius: 10, fontSize: 13, fontWeight: 600,
              border: 'none', cursor: 'pointer',
              background: 'linear-gradient(135deg, #059669, #10b981)', color: '#fff',
              boxShadow: '0 4px 12px rgba(5,150,105,0.3)',
            }}>
              <Svg type="check" size={14} /> Approve All ({pending.length})
            </button>
          </div>
        )}
      </div>

      {/* News List */}
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '64px 24px', background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb' }}>
          <div style={{ color: '#9ca3af', marginBottom: 16 }}><Svg type="newspaper" size={48} /></div>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: '#374151', margin: '0 0 8px' }}>
            {activeTab === 'pending' ? 'No pending news items' : news.length === 0 ? 'No news items yet' : 'No matching news items'}
          </h3>
          <p style={{ fontSize: 14, color: '#9ca3af', margin: '0 0 24px' }}>
            {activeTab === 'pending' ? 'Click "Fetch Industry News" to pull the latest headlines.' : 'Fetch industry news or write custom segments.'}
          </p>
          {activeTab === 'pending' && (
            <button onClick={fetchIndustryNews} disabled={fetching} style={{
              padding: '12px 28px', borderRadius: 10, fontSize: 14, fontWeight: 600,
              border: 'none', background: fetching ? '#93c5fd' : 'linear-gradient(135deg, #2563eb, #3b82f6)',
              color: '#fff', cursor: fetching ? 'not-allowed' : 'pointer',
            }}>{fetching ? 'Fetching...' : 'Fetch Industry News'}</button>
          )}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {filtered.map(item => {
            const catInfo = getCategoryInfo(item.category);
            const rss = isRSS(item.source);
            return (
              <div key={item.id} style={{
                background: item.is_active ? '#fff' : '#fffdf7',
                borderRadius: 16, border: item.is_active ? '1px solid #e5e7eb' : '1px solid #fde68a',
                overflow: 'hidden', transition: 'box-shadow 0.15s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
              >
                <div style={{ padding: '18px 22px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 6 }}>
                        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: 0 }}>{item.title}</h3>
                        <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: catInfo.bg, color: catInfo.color }}>{catInfo.label}</span>
                        {rss && (
                          <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Svg type={(item.source || '').toLowerCase().includes('local') ? 'pin' : 'globe'} size={10} />
                            {(item.source || '').toLowerCase().includes('local') ? 'Local' : 'Global'}
                          </span>
                        )}
                        {!item.is_active && (
                          <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#fffbeb', color: '#d97706', display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Svg type="clock" size={10} /> Pending
                          </span>
                        )}
                      </div>
                      <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 8px', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{item.content}</p>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14, fontSize: 11, color: '#9ca3af' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Svg type="calendar" size={10} /> {formatDate(item.publish_date)}</span>
                        {item.source && <span>{item.source}</span>}
                        {item.is_active && item.audio_url && <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#ecfdf5', color: '#059669', display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 6, height: 6, borderRadius: '50%', background: '#059669', display: 'inline-block', animation: 'pulse 2s infinite' }}></span> Live in Broadcast</span>}
                        {!item.is_active && item.audio_url && <span style={{ color: '#9ca3af', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 3, fontSize: 11 }}><Svg type="volume" size={10} /> Audio ready</span>}
                        <span>~{Math.ceil((item.content || '').split(' ').length / 150)} min read</span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                      {!item.is_active && (
                        <>
                          <button onClick={() => handleApprove(item.id)} disabled={approving === item.id} style={{
                            display: 'flex', alignItems: 'center', gap: 5, padding: '7px 14px', borderRadius: 8,
                            fontSize: 12, fontWeight: 600, border: 'none', cursor: approving === item.id ? 'not-allowed' : 'pointer',
                            background: '#ecfdf5', color: '#059669', opacity: approving === item.id ? 0.6 : 1,
                          }}>
                            <Svg type="check" size={12} /> {approving === item.id ? 'Generating...' : 'Approve'}
                          </button>
                          <button onClick={() => handleReject(item.id, item.title)} disabled={approving === item.id} style={{
                            padding: '7px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                            border: 'none', cursor: 'pointer', background: '#fef2f2', color: '#dc2626',
                          }}><Svg type="x" size={12} /></button>
                        </>
                      )}
                      {item.audio_url && (
                        <button onClick={() => playAudio(item.audio_url, item.id)} style={{
                          display: 'flex', alignItems: 'center', gap: 5, padding: '7px 14px', borderRadius: 8,
                          fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer',
                          background: playingId === item.id ? '#7c3aed' : '#f5f3ff',
                          color: playingId === item.id ? '#fff' : '#7c3aed',
                        }}>
                          <Svg type={playingId === item.id ? 'stop' : 'play'} size={12} />
                          {playingId === item.id ? 'Stop' : 'Play'}
                        </button>
                      )}
                      <button onClick={() => openEdit(item)} style={{
                        padding: 7, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#9ca3af',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#7c3aed'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}
                      ><Svg type="edit" size={14} /></button>
                      <button onClick={() => handleDelete(item.id, item.title)} style={{
                        padding: 7, borderRadius: 8, border: 'none', cursor: 'pointer', background: 'transparent', color: '#d1d5db',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}
                      ><Svg type="trash" size={14} /></button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* CREATE/EDIT MODAL */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16, backdropFilter: 'blur(4px)' }}>
          <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 520, maxHeight: '90vh', overflowY: 'auto', padding: 32, boxShadow: '0 25px 60px rgba(0,0,0,0.15)' }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: '0 0 24px' }}>
              {editing ? 'Edit News Item' : 'Write Custom News'}
            </h2>
            <form onSubmit={editing ? handleEdit : handleCreate}>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Headline *</label>
                <input type="text" required value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="e.g. New Store Hours Starting Next Week" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                  Content * <span style={{ color: '#9ca3af', fontWeight: 400 }}>&mdash; this gets read on-air</span>
                </label>
                <textarea required rows={5} value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  placeholder="Write the news segment as you want it read on air..."
                  style={{ ...inputStyle, resize: 'vertical' }} onFocus={focusIn} onBlur={focusOut} />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                  <span style={{ fontSize: 11, color: '#9ca3af' }}>{formData.content.length} characters</span>
                  <span style={{ fontSize: 11, color: '#9ca3af' }}>~{Math.ceil(formData.content.split(' ').filter(Boolean).length / 150)} min read</span>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 18 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Category</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {CATEGORIES.map(c => (
                      <button key={c.value} type="button" onClick={() => setFormData({ ...formData, category: c.value })}
                        style={{
                          padding: '5px 12px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                          border: formData.category === c.value ? `2px solid ${c.color}` : '1.5px solid #e5e7eb',
                          background: formData.category === c.value ? c.bg : '#fff',
                          color: formData.category === c.value ? c.color : '#6b7280',
                          cursor: 'pointer',
                        }}>{c.label}</button>
                    ))}
                  </div>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Source</label>
                  <input type="text" value={formData.source} onChange={(e) => setFormData({ ...formData, source: e.target.value })}
                    placeholder="e.g. AP News, Internal" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 12, borderTop: '1px solid #f3f4f6', paddingTop: 20 }}>
                <button type="button" onClick={closeModal} style={{
                  flex: 1, padding: '12px 20px', borderRadius: 10, border: '1.5px solid #e5e7eb',
                  background: '#fff', color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: "'Outfit', sans-serif",
                }}>Cancel</button>
                <button type="submit" disabled={saving} style={{
                  flex: 1, padding: '12px 20px', borderRadius: 10, border: 'none',
                  background: saving ? '#c4b5fd' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
                  color: '#fff', fontSize: 14, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer',
                  fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
                }}>{saving ? 'Saving...' : (editing ? 'Save Changes' : 'Create News')}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}